import styled from "styled-components";
import { Room } from "../../../../interfaces/Room";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../../../components/layouts/Card";
import { API_URL_BOOKING } from "../../../../helpers/api";
import Button from "../../../../components/forms/ButtonEx";
import { RootState } from "../../../../redux/rootReducers";
import { BookingRoom } from "../../../../interfaces/Booking";
import { ErrorResponse } from "../../../../interfaces/Response";
import NotificationBar from "../../../../components/NotificationBar";
import { DataTableWrapper } from "../../../../components/data/DataTable";
import { searchBookingAsyncResponse } from "../../../../redux/reducers/bookings/types";
import { setBooking, setError } from "../../../../redux/reducers/bookings/actions";

const BookingCreateRooms = () => {
  const dispatch = useDispatch();
  const [roomOptions, setRoomOptions] = useState<Room[]>([]);
  const [selectedRooms, setSelectedRooms] = useState<Room[]>([]);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [searchHasError, setSearchHasError] = useState<boolean>(false);
  const roomItems = useSelector((state: RootState) => state.room.rooms);
  const token = useSelector((state: RootState) => state.authorization.token);
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  const booking = useSelector((state: RootState) => state.booking.updatedBooking);
  const formExEndTime = useSelector((state: RootState) => state.booking.formExtension.end_time);
  const formExStartTime = useSelector((state: RootState) => state.booking.formExtension.start_time);

  const raiseError = () => {
    setSearchHasError(true);
    setSearchLoading(false);
    setRoomOptions([]);
  }

  const actionFindRoom = () => {
    if (isLoading) return;
    
    const errors: ErrorResponse = {
      status: 402,
      message: 'Semua kolom isian wajib diisi',
      errors: {}
    }
    if (!booking || !formExEndTime || !formExStartTime) {
      errors.errors = {
        ...errors.errors,
        start_date_time: ['Jam mulai kegiatan wajib diisi'],
        end_date_time: ['Jam selesai kegiatan wajib diisi']
      }
      dispatch(setError(errors));
      raiseError();
      return;
    }

    if (!booking.start_date) {
      errors.errors = {
        ...errors.errors,
        start_date: ['Tanggal kegiatan wajib diisi']
      }
      dispatch(setError(errors));
      raiseError();
      return;
    }

    setSearchLoading(true);
    setSearchHasError(false);
    const _startTime = `${booking.start_date} ${formExStartTime?.value}`;
    const _endTime = `${booking.start_date} ${formExEndTime?.value}`;
    const payload: any = {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json; charset=utf-8',
        'Accept': 'application/json; charset=utf-8'
      },
    };
    fetch(API_URL_BOOKING.SEARCH_BOOKING(_startTime, _endTime), payload).then(response => {
      response.json().then((result: searchBookingAsyncResponse) => {
        const _roomOptions: Room[] = [...roomItems];
        result.data.forEach(bookingItem => {
          if (bookingItem.rooms.length > 0) {
            bookingItem.rooms.forEach(roomItem => {
              const deleteIndex = _roomOptions.findIndex(i => i.id === roomItem.id_room);
              if (deleteIndex > -1) {
                _roomOptions.splice(deleteIndex, 1);
              }
            })
          }
        });
        setRoomOptions([..._roomOptions]);
      });
    }).catch(() => {
      raiseError();
    }).finally(() => {
      setSearchHasError(false);
      setSearchLoading(false);
    });
  }

  const selectRoom = (room: Room | undefined) => {
    if (!room) return false;
    const newSelectedRooms = [...selectedRooms];
    const selectedRoomIndex = newSelectedRooms.findIndex(i => i.id === room.id);
    if (selectedRoomIndex >= 0) {
      newSelectedRooms.splice(selectedRoomIndex, 1);
    } else {
      newSelectedRooms.push(room);
    };
    setSelectedRooms(newSelectedRooms);
  }

  const isRoomSelected = (roomId: number | undefined) => {
    if (typeof roomId === 'undefined') return false;
    if (selectedRooms.find(r => r.id === roomId)) return true;
    return false;
  }

  const actionConfirmRoom = () => {
    if (!booking || isLoading) return;

    const newRooms: BookingRoom[] = [];
    selectedRooms.forEach(room => {
      const roomId = room.id;
      if (roomId) {
        newRooms.push({
          id_room: roomId,
          room_detail: room
        });
      }
    });
    dispatch(setBooking({
      ...booking,
      rooms: newRooms
    }));
  }

  const actionRepickRoom = () => {
    if (!booking || isLoading) return;
    dispatch(setBooking({
      ...booking,
      rooms: []
    }));
  }

  const renderRoomOptions = () => {
    return (
      <React.Fragment>
        <Button
          noBlock 
          disabled={isLoading || searchLoading}
          isLoading={isLoading || searchLoading}
          onClick={actionFindRoom}
          caption={`Perbaharui Daftar Ruangan`}
        />
        <DataTableWrapper style={{ marginBottom: '20px' }}>
          <div className="tablewrapper--table">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Nama</th>
                  <th>Kapasitas</th>
                </tr>
              </thead>
              <tbody>
                {
                  roomOptions.map(room => {
                    return (
                      <tr>
                        <td><input type="checkbox" onClick={() => selectRoom(room)} checked={isRoomSelected(room.id)}  /></td>
                        <td>{room.room_name}</td>
                        <td>10 orang</td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
        </DataTableWrapper>
        <Button
          noBlock 
          disabled={isLoading || searchLoading}
          isLoading={isLoading || searchLoading}
          onClick={actionConfirmRoom}
          caption={`Konfirmasi Ruangan`}
        />
      </React.Fragment>
    );
  }

  const renderRoomResult = () => {
    if (!booking) return <div />;

    return (
      <React.Fragment>
        <DataTableWrapper style={{ marginTop: 0, marginBottom: '20px' }}>
          <div className="tablewrapper--table">
            <table>
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Kapasitas</th>
                </tr>
              </thead>
              <tbody>
                {
                  booking.rooms.map(room => {
                    return (
                      <tr>
                        <td>{room.room_detail?.room_name}</td>
                        <td>10 orang</td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
        </DataTableWrapper>
        <Button
          noBlock 
          disabled={isLoading || searchLoading}
          isLoading={isLoading || searchLoading}
          onClick={actionRepickRoom}
          caption={`Perbaharui Ruangan`}
        />
      </React.Fragment>
    );
  }

  const renderRoomFindInfo = () => {
    return (
      <React.Fragment>
        <NotificationBar type="info">
          <React.Fragment>
            <p style={{ marginBottom: '10px' }}><span className={`${searchHasError ? 'search-has-error' : ''}`}>Lengkapi <b>estimasi jumlah peserta</b>, <b>tanggal peminjaman</b>, dan <b>durasi peminjaman</b> untuk mencari ruangan yang dapat Anda gunakan.</span> Mohon menggunakan ruangan yang sesuai dengan kapasitas jumlah peserta yang dibutuhkan atau permintaan dapat ditolak.</p>

            <Button
              noBlock 
              disabled={isLoading || searchLoading}
              isLoading={isLoading || searchLoading}
              onClick={actionFindRoom}
              caption={`Cari Ruangan`}
            />
          </React.Fragment>
        </NotificationBar>
      </React.Fragment>
    )
  }

  if (!booking) return <div />;

  return (
    <BookingCreateRoomsWrapper>
      <Card>
        <div className="card--title">
          <h2 className="card--title-title">Cari Ruangan</h2>
        </div>
        <div className="card--body">
          {(() => {
            if (booking.rooms.length === 0) {
              if (roomOptions.length === 0) {
                return renderRoomFindInfo();
              } else {
                return renderRoomOptions();
              }
            } else {
              return renderRoomResult();
            }
          })()}
        </div>
      </Card>
    </BookingCreateRoomsWrapper>
  )
}

const BookingCreateRoomsWrapper = styled.div`
  .search-has-error {
    /* color: red;
    font-weight: 700;
    text-decoration: underline */
  }
`;

export default BookingCreateRooms;